import { z } from 'zod';
/** Route params for the endpoints addressing a single feed. */
export const FeedIdParamsSchema = z.object({ feedId: z.uuid() }).strict();
/** Route params for attaching a practice to a feed, or detaching it. */
export const FeedPracticeParamsSchema = z
    .object({ feedId: z.uuid(), practiceId: z.uuid() })
    .strict();
//# sourceMappingURL=params.js.map